import { render, staticRenderFns } from "./PassageAndBundleQuestion.vue?vue&type=template&id=526a7610&scoped=true"
import script from "./PassageAndBundleQuestion.vue?vue&type=script&lang=js"
export * from "./PassageAndBundleQuestion.vue?vue&type=script&lang=js"
import style0 from "./PassageAndBundleQuestion.vue?vue&type=style&index=0&id=526a7610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a7610",
  null
  
)

export default component.exports